var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69.054c-.432.144-.848.545-.972.937-.144.459.024 1.054.391 1.383.81.724 2.17.414 2.49-.567C5.887.924 5.226.044 4.244.002a1.72 1.72 0 0 0-.553.052Zm-1.522 4.02c-.315.057-1.573.496-1.64.573-.052.06-.219.644-.192.672.009.008.15-.028.313-.08.642-.205 1.24-.11 1.395.222.165.353.085.844-.428 2.632-.397 1.382-.466 1.71-.473 2.244-.005.346.013.467.1.668.135.315.471.635.866.824.278.132.362.149.846.166.646.024.952-.037 1.812-.357l.598-.224.09-.315c.048-.173.077-.325.064-.34-.013-.013-.115.011-.227.054-.298.114-1.073.116-1.275.003-.48-.267-.451-.719.195-2.977.404-1.411.44-1.584.444-2.135.006-.782-.242-1.187-.925-1.508-.266-.125-.355-.142-.805-.154a4.955 4.955 0 0 0-.758.032Z",
    fill: "#A4AAB0"
  })));
};

export default SvgExclamation;